import type { ReactNode } from 'react';
import { NumericFormat as NumberFormat } from 'react-number-format';

export interface INumericMetricWidgetProps {
  title: string;
  value: number | string | React.ReactNode;
  icon?: ReactNode;
  prefix?: string;
  suffix?: string;
}

export default function NumericMetricWidget(props: INumericMetricWidgetProps) {
  const { title, value, icon, prefix, suffix } = props;

  return (
    <div className='bg-white rounded-md flex flex-row p-4 relative h-full'>
      <div className='flex-grow flex flex-col justify-between gap-8'>
        <div className='flex gap-3 font-bold'>
          <span className='text-md'>{title}</span>
        </div>
        <span className='text-primaryColor-normal text-4xl lg:text-5xl w-full '>
          <NumberFormat
            value={value?.toString() ?? ''}
            displayType='text'
            thousandSeparator={true}
            prefix={prefix}
            suffix={suffix}
            valueIsNumericString
          />
        </span>
      </div>
      {icon && <div className='p-1'>{icon}</div>}
    </div>
  );
}
